import { render, staticRenderFns } from "./RaceVideoHighlightsPane.vue?vue&type=template&id=28fabe66&scoped=true"
import script from "./RaceVideoHighlightsPane.vue?vue&type=script&lang=ts"
export * from "./RaceVideoHighlightsPane.vue?vue&type=script&lang=ts"
import style0 from "./RaceVideoHighlightsPane.vue?vue&type=style&index=0&id=28fabe66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fabe66",
  null
  
)

export default component.exports